import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

const LANGS = [
  { code: "es", label: "Español", flag: "ES" },
  { code: "fr", label: "Français", flag: "FR" },
  { code: "en", label: "English", flag: "EN" },
];

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = LANGS.find((l) => i18n.resolvedLanguage?.startsWith(l.code)) || LANGS[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="lang-switcher-trigger"
          aria-label={t("nav.language")}
          className="inline-flex items-center gap-2 h-9 px-3 rounded-lg border border-border/70 bg-secondary/60 hover:bg-secondary transition text-sm font-medium"
        >
          <Globe className="w-4 h-4 opacity-70" />
          <span className="font-mono text-xs tracking-wider">{current.flag}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="bg-card border-border min-w-[160px]"
        data-testid="lang-switcher-menu"
      >
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onSelect={() => i18n.changeLanguage(l.code)}
            className={`cursor-pointer ${
              current.code === l.code ? "text-primary" : ""
            }`}
          >
            <span className="font-mono text-xs w-7 opacity-70">{l.flag}</span>
            <span>{l.label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
